import { render, staticRenderFns } from "./ProductShipping.vue?vue&type=template&id=0ddf1d38&"
import script from "./ProductShipping.vue?vue&type=script&lang=js&"
export * from "./ProductShipping.vue?vue&type=script&lang=js&"
import style0 from "./ProductShipping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports